import type { ReactNode } from 'react';
import { memo, Component } from 'react';

interface MessageHandler {
  (event: MessageEvent): void;
}

type PropsType<T> = T extends Component<infer P> ? P : never;

export const MessageListener = memo(
  class MessageListener extends Component<{ children: ReactNode; onMessage?: MessageHandler }> {
    #onMessage: MessageHandler;

    constructor(props: PropsType<MessageListener>) {
      super(props);
      this.#onMessage = (e: MessageEvent) => {
        this.props.onMessage?.call(this, e);
      };
    }

    componentDidMount() {
      window.addEventListener('message', this.#onMessage);
    }
    componentWillUnmount() {
      window.removeEventListener('message', this.#onMessage);
    }

    render(): ReactNode {
      return this.props.children;
    }
  },
);
